import React from 'react';
import KartenverwaltungHeader from '../components/dashboard/kartenverwaltung/KartenverwaltungHeader';
import KartenNavigation from '../components/dashboard/kartenverwaltung/KartenNavigation';
import CardList from '../components/dashboard/kartenverwaltung/CardList';
import { KartenverwaltungDetail } from '../components';

const Kartenverwaltung = () => {
  return (
    <>
      <KartenNavigation />
      <KartenverwaltungHeader />
      <CardList />
      <KartenverwaltungDetail />
    </>
  );
};

export default Kartenverwaltung;
